import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  AdminCitiesApiResponse,
  CityItem,
  CreateCityRequest,
} from './admin-cities.models';

@Injectable({
  providedIn: 'root',
})
export class AdminCitiesApi {
  private readonly http = inject(HttpClient);
  private readonly adminCitiesUrl = `${environment.apiUrl}/admin/cities`;
  private readonly citiesUrl = `${environment.apiUrl}/cities`;

  createCity(payload: CreateCityRequest): Observable<AdminCitiesApiResponse<CityItem>> {
    return this.http.post<AdminCitiesApiResponse<CityItem>>(this.adminCitiesUrl, payload);
  }

  deleteCity(id: string): Observable<AdminCitiesApiResponse<{ id: string }>> {
    return this.http.delete<AdminCitiesApiResponse<{ id: string }>>(`${this.adminCitiesUrl}/${id}`);
  }

  getCities(): Observable<AdminCitiesApiResponse<CityItem[]>> {
    return this.http.get<AdminCitiesApiResponse<CityItem[]>>(this.citiesUrl);
  }
}
